export * from './generic-resource.module';
export * from './generic-resource.service';
